"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinancialStatementFacade = exports.createFinancialStatementFacade = exports.FSModels = void 0;
const dotnet_1 = __importDefault(require("./dotnet"));
var dotnet_2 = require("./dotnet");
Object.defineProperty(exports, "FSModels", { enumerable: true, get: function () { return dotnet_2.FS; } });
const protocol_buffers_1 = __importDefault(require("protocol-buffers"));
var bootInteropPromise = dotnet_1.default.boot();
function createFinancialStatementFacade(webApiModel = undefined, financialStatementType = dotnet_1.default.FS.FinancialStatementType.BalanceSheet, reportingPeriod = dotnet_1.default.FS.ReportingPeriodTypes.FiscalYearsAndTTM, sortReportingPeriods = dotnet_1.default.FS.ChronologicalSortOrder.OldestFirst) {
    return __awaiter(this, void 0, void 0, function* () {
        return bootInteropPromise
            .then(() => new FinancialStatementFacade(dotnet_1.default.FS.FinancialStatementEditorInterop, webApiModel || dotnet_1.default.FS.FinancialStatementEditorInterop.createMockFinancialStatements(), financialStatementType, reportingPeriod, sortReportingPeriods));
    });
}
exports.createFinancialStatementFacade = createFinancialStatementFacade;
class FinancialStatementFacade {
    constructor(interop, webApiModel, financialStatementType, reportingPeriod, sortReportingPeriods = dotnet_1.default.FS.ChronologicalSortOrder.OldestFirst) {
        this.interop = interop;
        this.financialStatementType = financialStatementType;
        this.reportingPeriod = reportingPeriod;
        this.sortReportingPeriods = sortReportingPeriods;
        const textEncoder = new TextEncoder();
        this.objectId = interop.initialize(textEncoder.encode(JSON.stringify(webApiModel)));
        var protobufMessageDef = interop.getProtoForViewModel();
        var messages = (0, protocol_buffers_1.default)(protobufMessageDef);
        this.protobufDecoder = messages.FinancialStatementViewModel.decode;
        this.lineItemTypes = interop.getLineItemTypes();
    }
    renderFinancialStatement(scalingFactorOverride) {
        return this.protobufDecoder(this.interop.renderFinancialStatementProtobuf(this.objectId, this.financialStatementType, this.lineItemTypes, this.reportingPeriod, this.basisOfAccounting, this.sortReportingPeriods, scalingFactorOverride));
    }
    getWebApiModel() {
        return this.interop.getWebApiModel(this.objectId);
    }
    setFinancialStatementType(financialStatementType) {
        this.financialStatementType = financialStatementType;
    }
    setReportingPeriod(reportingPeriod) {
        this.reportingPeriod = reportingPeriod;
    }
    setChronologicalSortOrder(sortReportingPeriods) {
        this.sortReportingPeriods = sortReportingPeriods;
    }
    usePredefinedNumberStyle(predefinedNumberStyle) {
        this.interop.usePredefinedNumberStyle(this.objectId, predefinedNumberStyle);
    }
    getPredefinedNumberStyleInUse() {
        return this.interop.getPredefinedNumberStyleInUse(this.objectId);
    }
    setLineItemTypes(lineItemTypes) {
        this.lineItemTypes = lineItemTypes;
    }
    getCurrentBasisOfAccounting() {
        if (!this.basisOfAccounting) {
            this.basisOfAccounting = this.renderFinancialStatement().data[0].basisOfAcounting;
        }
        return this.basisOfAccounting;
    }
    setBasisOfAccounting(basisOfAccounting) {
        this.basisOfAccounting = basisOfAccounting;
    }
    getAvailableBasisOfAccounting() {
        return this.interop.getAvailableBasisOfAccounting(this.objectId);
    }
    addClassificationSection(request) {
        this.interop.addClassificationSection(this.objectId, this.financialStatementType, request);
    }
    deleteClassificationSection(sectionId, relocateContentsToSectionId) {
        this.interop.deleteClassificationSection(this.objectId, this.financialStatementType, sectionId, relocateContentsToSectionId);
    }
    setReportedAs(sectionId, reportedAs) {
        this.interop.setReportedAs(this.objectId, this.financialStatementType, sectionId, reportedAs);
    }
    editCaptionText(edits) {
        this.interop.editCaptionText(this.objectId, this.financialStatementType, edits);
    }
    getValidLocationsToMoveLineItem(lineItemId) {
        return this.interop.getValidLocationsToMoveLineItem(this.objectId, this.financialStatementType, lineItemId);
    }
    incrementSortOrder(lineItemId) {
        return this.interop.incrementSortOrder(this.objectId, this.financialStatementType, lineItemId);
    }
    decrementSortOrder(lineItemId) {
        return this.interop.decrementSortOrder(this.objectId, this.financialStatementType, lineItemId);
    }
    sortLineItems(orderBy = dotnet_1.default.FS.OrderLineItemsBy.CaptionText, orderSubsections = dotnet_1.default.FS.OrderSubsections.PreserveCurrentSortOrder, sectionId, reportingPeriodId) {
        return this.interop.sortLineItems(this.objectId, this.financialStatementType, orderBy, orderSubsections, sectionId, reportingPeriodId);
    }
    moveLineItems(requests) {
        this.interop.moveLineItems(this.objectId, this.financialStatementType, requests);
    }
    deleteLineItems(requests) {
        this.interop.deleteLineItems(this.objectId, this.financialStatementType, requests);
    }
    dispose() {
        this.interop.dispose(this.objectId);
    }
}
exports.FinancialStatementFacade = FinancialStatementFacade;
//# sourceMappingURL=index.js.map